import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import toastr from "toastr";

// Login Redux States
import {
  SEND_BATCH_MAIL,
  BATCH_MAIL_LIST,

} from "./actionTypes"
import { mailBatchSuccess, mailBatchError } from "./actions"

import {
  onSendBatchEmail,
  onListBatchMail,
} from "helpers/backend_api_helper";

// add MailBatch
function* sendMailBatch({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onSendBatchEmail, data);
    yield put(mailBatchSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(mailBatchError(error?.response?.data?.message || "Server Error"));
  }
}


// list MailBatch
function* listMailBatch({ payload: { data, callback } }) {
  try {
    const response = yield call(onListBatchMail, data);
    yield put(mailBatchSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(mailBatchError(error?.response?.data?.message || "Server Error"));
  }
}


function* MailBatchSaga() {
  yield takeEvery(SEND_BATCH_MAIL, sendMailBatch);
  yield takeEvery(BATCH_MAIL_LIST, listMailBatch);

}

export default MailBatchSaga;

